// extracted by mini-css-extract-plugin
module.exports =  {"root":"HorizonSelector-module__root--i1VMY"};